// @ts-nocheck
export const RESOURCES_TYPES = {
  INVOICE: 'invoice',
  ESTIMATE: 'estimate',
  PRESENTATION: 'presentation',
  RECEIPT: 'receipt',
  PAYMENT_RECEIVE: 'payment_receive',
  PAYMENT_MADE: 'payment_made',
  CUSTOMER: 'customer',
  VENDOR: 'vendor',
  CUSTOMER_DEPOSITS: 'customer_deposits',
  ITEM: 'item',
  BILL: 'bill',
  PURCHASE_ORDER: 'purchase_order',
  SALES_ORDER: 'sales_order',
  EXPENSE: 'expense',
  MANUAL_JOURNAL: 'manual_journal',
  ACCOUNT: 'account',
  CREDIT_NOTE: 'credit_note',
  VENDOR_CREDIT:'vendor_credit'
};
